"use client";
import { type PropsWithChildren } from "react";
import { useHideNavMenuOnPage } from "../hooks/useHideNavMenuOnPage";

export interface ConditionalNavWrapperProps {
  hideNavForPagePaths: string[];
}

export default function ConditionalNavWrapper(
  props: PropsWithChildren<ConditionalNavWrapperProps>,
) {
  const { hideNavForPagePaths, children } = props;
  const isNavHidden = useHideNavMenuOnPage(hideNavForPagePaths);

  return isNavHidden ? null : children;
}
